module.exports = __webpack_public_path__ + "img/tremor-logo.413f3098.png";